import React from 'react';
import { nextSteps } from '../data/bonuses';
import { SectionHeading } from './SectionHeading';
export function NextSteps() {
  return <section className="bg-cream" data-id="element-168" data-mp="30nye9j4jz5y">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-169" data-mp="34lgqsxvomos">
        <SectionHeading eyebrow="Después de la guía" title={<>
              Tus próximos pasos <span className="text-clay" data-id="element-171" data-mp="3pb09idn5r9ur">en Feng Shui</span>
            </>} subtitle="Después de aprender las bases con Armonía Interior, podés profundizar específicamente en dos de las áreas que más interés generan dentro del Feng Shui." data-id="element-170" data-mp="3u8sby1lfied7" />

        <ul className="mx-auto mt-12 grid max-w-4xl gap-8 sm:mt-16 sm:grid-cols-2 sm:gap-10" data-id="element-172" data-mp="h20eckyac0ru">
          {nextSteps.map(step => <li key={step.title} className="flex h-full flex-col" data-id="element-173" data-mp="c3fbsevk9508">
              <img src={step.image} alt={step.imageAlt} className="aspect-[4/3] w-full rounded-2xl object-cover shadow-soft" loading="lazy" data-id="element-174" data-mp="c12wyal3nare" />
              <h3 className="mt-6 font-display text-[22px] font-semibold leading-snug text-ink sm:text-[25px]" data-id="element-175" data-mp="14rb4z9lx8es9">
                {step.title}
              </h3>
              {step.paragraphs.map((paragraph, index) => <p key={paragraph} className={`mt-3 leading-[1.7] text-ink-soft ${index === 0 ? 'text-[14.5px] sm:text-[15px]' : 'text-[13.5px] sm:text-[14px]'}`} data-id="element-176" data-mp="3diz27fkq5dq" data-mpi={index}>
                  {paragraph}
                </p>)}
              <p className="mt-auto pt-6 text-[11.5px] uppercase tracking-[0.12em] text-clay" data-id="element-177" data-mp="3qp22qnqtu013">
                {step.note}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}